import { useEffect, useState, useCallback } from 'react'
import { Search } from 'lucide-react'
import api from '../api/client'
import Pagination from '../components/Pagination'
import SearchableSelect from '../components/SearchableSelect'

const dt = (s) => (s ? new Date(s).toLocaleString('pt-BR') : '—')
const COR = {
  importacao: 'bg-indigo-100 text-indigo-700', status: 'bg-emerald-100 text-emerald-700',
  comissao: 'bg-teal-100 text-teal-700', estorno: 'bg-rose-100 text-rose-700',
  chargeback: 'bg-rose-100 text-rose-700', reprocessamento: 'bg-blue-100 text-blue-700',
  alteracao_manual: 'bg-amber-100 text-amber-700',
}
const ACOES = [
  { value: 'importacao', label: 'Importação' }, { value: 'status', label: 'Alteração de status' },
  { value: 'comissao', label: 'Comissão gerada' }, { value: 'estorno', label: 'Estorno' },
  { value: 'reprocessamento', label: 'Reprocessamento' }, { value: 'alteracao_manual', label: 'Alteração manual' },
]

export default function Auditoria() {
  const [rows, setRows] = useState([])
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(30)
  const [meta, setMeta] = useState({ total: 0, pages: 1 })
  const [acao, setAcao] = useState('')
  const [search, setSearch] = useState('')

  const load = useCallback((p = 1, sz = size) => {
    const qs = `${acao ? `&acao=${acao}` : ''}${search ? `&search=${encodeURIComponent(search)}` : ''}`
    api.get(`/auditoria?page=${p}&limit=${sz}${qs}`).then((r) => {
      setRows(r.data.data || []); setMeta({ total: r.data.total || 0, pages: r.data.pages || 1 }); setPage(p)
    }).catch(() => {})
  }, [size, acao, search])

  useEffect(() => { load(1) }, [acao]) // eslint-disable-line

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-heading font-bold text-gray-900">Log de Auditoria</h1>
        <p className="text-sm text-gray-500 mt-0.5">Rastreabilidade: importações, pagamentos, comissões, estornos e alterações — com usuário, data e hora.</p>
      </div>

      <div className="flex items-center gap-2 flex-wrap">
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
          <input value={search} onChange={(e) => setSearch(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && load(1)}
            placeholder="Buscar no detalhe / usuário..."
            className="border border-gray-200 rounded-xl pl-9 pr-3 py-2 text-sm outline-none focus:border-accent-400 w-72" />
        </div>
        <div className="w-56"><SearchableSelect value={acao} onChange={setAcao} emptyLabel="Todas as ações" options={ACOES} /></div>
        <button onClick={() => load(1)} className="rounded-xl bg-gray-900 text-white px-4 py-2 text-sm font-semibold">Filtrar</button>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-gray-500 text-left text-xs uppercase tracking-wider">
            <tr><th className="px-4 py-3">Data/Hora</th><th className="px-4 py-3">Usuário</th><th className="px-4 py-3">Ação</th><th className="px-4 py-3">Entidade</th><th className="px-4 py-3">Detalhe</th></tr>
          </thead>
          <tbody>
            {rows.map((a) => (
              <tr key={a.id} className="border-t border-gray-100 hover:bg-primary-50/30">
                <td className="px-4 py-2.5 text-gray-500 whitespace-nowrap">{dt(a.created_at)}</td>
                <td className="px-4 py-2.5">{a.usuario_nome || '—'}</td>
                <td className="px-4 py-2.5"><span className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${COR[a.acao] || 'bg-gray-100 text-gray-600'}`}>{a.acao}</span></td>
                <td className="px-4 py-2.5 text-gray-500">{a.entidade}{a.entidade_id ? ` #${a.entidade_id}` : ''}</td>
                <td className="px-4 py-2.5 text-gray-700">{a.detalhe}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-gray-400">Nenhum registro.</td></tr>}
          </tbody>
        </table>
      </div>
      <Pagination page={page} pages={meta.pages} total={meta.total} pageSize={size} onPage={load} onPageSize={(n) => { setSize(n); load(1, n) }} />
    </div>
  )
}
